<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <label class="control-label">Taxa de admissão</label>
    </div>
    <div class="panel-body admission-payment-rule__form">
      <loading v-if="loading" full-parent size="small" />
      <div class="col-md-8 col-md-offset-2">
        <table class="table table-bordered ">
          <colgroup>
            <col class="col-md-4">
            <col class="col-md-4">
          </colgroup>
          <tbody>
            <tr>
              <td>
                <strong>Habilitar</strong>
              </td>
              <td>
                <select-field
                  :value="form.get('enabled').value"
                  :errors="form.get('enabled').errors"
                  @input="emitFormFieldChanged('enabled', $event)"
                  :options="commomTypes"
                />
              </td>
            </tr>
            <template v-if="isAdmissionPaymentEnabled">
              <tr>
                <td>
                  <strong>Tipo de taxa</strong>
                </td>
                <td>
                  <select-field
                    placeholder=" "
                    :value="form.get('amountType').value"
                    :errors="form.get('amountType').errors"
                    @input="emitFormFieldChanged('amountType', $event)"
                    :options="admissionAmountTypes"
                  />
                </td>
              </tr>
              <tr v-if="isPercentageAmountType">
                <td>
                  <strong>Porcentagem</strong>
                </td>
                <td>
                  <input-field
                    input-group-text-append="%"
                    :value="form.get('percentage').value"
                    :mask="'###'"
                    :errors="form.get('percentage').errors"
                    @input="emitFormFieldChanged('percentage', Number($event))"
                  />
                </td>
              </tr>
              <tr v-if="form.get('amountType').value === 'custom_amount'">
                <td>
                  <strong>Valor</strong>
                </td>
                <td>
                  <money-field
                    :value="form.get('amount').value"
                    :errors="form.get('amount').errors"
                    @input="emitFormFieldChanged('amount', $event)"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Equivale a primeira parcela</strong>
                </td>
                <td>
                  <select-field
                    :options="commomTypes"
                    :value="form.get('equivalentToFirstBill').value"
                    :errors="form.get('equivalentToFirstBill').errors"
                    @input="emitFormFieldChanged('equivalentToFirstBill', $event)"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { InputField, MoneyField, SelectField } from 'components/form';
import EnumsService from 'services/EnumsService';
import Loading from 'components/Loading';

export default {
  components: {
    InputField,
    MoneyField,
    SelectField,
    Loading,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commomTypes: [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ],
      admissionAmountTypes: [],
      loading: false,
    };
  },
  computed: {
    isPercentageAmountType() {
      return ['percentage_of_amount_with_discount', 'percentage_of_amount_without_discount'].includes(
        this.form.get('amountType').value,
      );
    },
    isAdmissionPaymentEnabled() {
      return /^true$/i.test(this.form.fields.enabled.value);
    },
  },
  mounted() {
    this.loading = true;

    EnumsService.getAdmissionAmountTypes()
      .then((admissionAmountTypes) => {
        this.admissionAmountTypes = admissionAmountTypes;
      })
      .catch(() => {
        this.$router.push('/');
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    emitFormFieldChanged(field, value) {
      this.$emit('form-field-changed', { [field]: value });
    },
  },
};
</script>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .admission-payment-rule__form {
    padding: $space-m $space-st $space-xxs $space-st;
    position: relative;
  }
</style>
